import type { I18nFn } from '#/i18n/types/I18nFn';

export function EVENT_RSVP_STATUSES(i18n: I18nFn) {
  return {
    GOING: i18n('Going'),
    INTERESTED: i18n('Interested'),
    NOT_GOING: i18n('Not going'),
  };
}
